export const Tabs = {
  baseStyle: () => {
    return {
      borderBottomColor: 'gray.200',
      borderBottomWidth: 4,
      flexGrow: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
    };
  },
};

export const Tab = {
  baseStyle: ({ active, label }: Record<string, any>) => {
    return {
      borderBottomWidth: 4,
      borderBottomColor: active ? 'blue.500' : 'gray.200',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: -1,
      px: 8,
      py: 2,

      _icon: {
        color: 'gray.800',
        marginRight: label ? 3 : 0,
        size: 'md',
      },
      _label: {
        color: 'gray.800',
        fontSize: 'md',
        lineHeight: 'md',
        fontWeight: active ? 600 : 400,
      },
      _pressableHover: {
        borderBottomColor: 'blue.400',
      },
      _iconHover: {
        color: 'blue.400',
      },
      _labelHover: {
        color: 'blue.400',
      },
    };
  },
};

export const TabPanel = {
  baseStyle: () => ({}),
};
